import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    this.setupScrollListener();
  }

  getCurrentYear(): number {
    return new Date().getFullYear();
  }

  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  setupScrollListener(): void {
    window.addEventListener('scroll', () => {
      const goTopButton = document.querySelector('.go-top');
      if (goTopButton) {
        if (window.scrollY > 300) {
          goTopButton.classList.add('active');
        } else {
          goTopButton.classList.remove('active');
        }
      }
    });
  }

}